import { Injectable } from '@angular/core';

export abstract class StorageService {
    abstract get(key: string): string;

    abstract set(key: string, value: string): void;

    abstract remove(key: string): void;
}

@Injectable()
export class BrowserStorageService extends StorageService {
    private store = {};
    private isStorageAvailable: boolean;

    constructor() {
        super();
        this.isStorageAvailable = this.checkIsStorageAvailable();
        if (!this.isStorageAvailable) {
            console.warn('Local Storage is not available.');
        }
    }

    get(key: string) {
        return this.isStorageAvailable
            ? window.localStorage.getItem(key)
            : this.store[key];
    }

    set(key: string, value: string) {
        this.isStorageAvailable 
            ? window.localStorage.setItem(key, value)
            : this.store[key] = value;
    }

    remove(key: string) {
        this.isStorageAvailable
            ? window.localStorage.removeItem(key)
            : delete this.store[key];
    }

    private checkIsStorageAvailable() {
        const supported = window && window.localStorage !== null;

        try {
            if (supported) {
                const key = Math.random().toString(36).substring(7);
                window.localStorage.setItem(key, '');
                window.localStorage.removeItem(key);
            }

            return supported;
        } catch (e) {
            return false;
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/storage.service.ts